var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "level" },
          [
            _c(
              "Header",
              _vm._b(
                { staticClass: "level-left" },
                "Header",
                _vm.$route.meta,
                false
              )
            ),
            _c(
              "b-button",
              {
                staticClass: "left-right",
                attrs: {
                  type: "is-success",
                  "icon-left": "plus",
                  disabled: _vm.selectedPlant === null,
                },
                on: {
                  click: function ($event) {
                    return _vm.showCreateForm()
                  },
                },
              },
              [_vm._v(" Create New Booking ")]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Start Date" } },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          name: "startdate",
                          "first-day-of-week": 1,
                          locale: "en-CA",
                          icon: "calendar-alt",
                          placeholder: "Start date",
                        },
                        model: {
                          value: _vm.start,
                          callback: function ($$v) {
                            _vm.start = $$v
                          },
                          expression: "start",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "End Date" } },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          name: "enddate",
                          "first-day-of-week": 1,
                          locale: "en-CA",
                          icon: "calendar-alt",
                          placeholder: "End date",
                        },
                        model: {
                          value: _vm.end,
                          callback: function ($$v) {
                            _vm.end = $$v
                          },
                          expression: "end",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.user.group.plants && _vm.user.group.plants.length != 0
                    ? _c(
                        "b-field",
                        { attrs: { label: "Plant" } },
                        [
                          _c(
                            "b-select",
                            {
                              attrs: { icon: "industry", expanded: "" },
                              model: {
                                value: _vm.selectedPlant,
                                callback: function ($$v) {
                                  _vm.selectedPlant = $$v
                                },
                                expression: "selectedPlant",
                              },
                            },
                            _vm._l(_vm.user.group.plants, function (plant) {
                              return _c(
                                "option",
                                { key: plant.id, domProps: { value: plant } },
                                [_vm._v(" " + _vm._s(plant.name) + " ")]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      )
                    : _c(
                        "b-field",
                        { attrs: { label: "Plant" } },
                        [
                          _c("multiselect", {
                            staticStyle: { "min-width": "400px" },
                            attrs: {
                              options: _vm.plants,
                              multiple: false,
                              "close-on-select": true,
                              placeholder: "Pick plant",
                              "custom-label": (obj) =>
                                obj.id + " - " + obj.name,
                              "track-by": "name",
                            },
                            model: {
                              value: _vm.selectedPlant,
                              callback: function ($$v) {
                                _vm.selectedPlant = $$v
                              },
                              expression: "selectedPlant",
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "left-right",
                      attrs: {
                        type: "is-warning",
                        "icon-left": "arrows-rotate",
                        disabled: _vm.isLoading || _vm.selectedPlant === null,
                      },
                      on: {
                        click: () => {
                          _vm.resetData()
                          _vm.getData()
                        },
                      },
                    },
                    [_vm._v(" Load ")]
                  ),
                ],
                1
              ),
              _vm.bookings.length != 0
                ? _c("ag-grid-vue", {
                    staticClass: "ag-theme-balham",
                    staticStyle: { width: "100%", height: "700px" },
                    attrs: {
                      "row-data": _vm.bookings,
                      "grid-options": _vm.gridOptions,
                      pagination: true,
                      "pagination-auto-page-size": true,
                      "cache-overflow-size": 0,
                      "multi-sort-key": "ctrl",
                      modules: _vm.modules,
                      "get-context-menu-items": _vm.getContextMenuItems,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isCreatingBooking,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCreatingBooking = $event
            },
          },
        },
        [
          _c("BookingForm", {
            attrs: { plant: _vm.selectedPlant },
            on: { submit: _vm.submitBooking },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditingBooking,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditingBooking = $event
            },
          },
        },
        [
          _vm.isEditingBooking
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitEdit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Edit Movement "),
                          _vm.selectedPlant
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "1rem",
                                    "text-overflow": "elipsis",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.selectedPlant.name))]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Crate Type" } },
                                [
                                  _c(
                                    "b-select",
                                    {
                                      attrs: { placeholder: "Crate Type" },
                                      model: {
                                        value: _vm.editableBooking.type,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.editableBooking,
                                            "type",
                                            $$v
                                          )
                                        },
                                        expression: "editableBooking.type",
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "1" } }, [
                                        _vm._v(" 1 "),
                                      ]),
                                      _c(
                                        "option",
                                        { attrs: { value: "5.1" } },
                                        [_vm._v(" 5.1 ")]
                                      ),
                                      _c(
                                        "option",
                                        { attrs: { value: "5.2" } },
                                        [_vm._v(" 5.2 ")]
                                      ),
                                      _c(
                                        "option",
                                        { attrs: { value: "5.5" } },
                                        [_vm._v(" 5.5 ")]
                                      ),
                                      _c(
                                        "option",
                                        { attrs: { value: "GPSFood" } },
                                        [_vm._v(" GPS Food ")]
                                      ),
                                      _c(
                                        "option",
                                        { attrs: { value: "ZEON" } },
                                        [_vm._v(" ZEON ")]
                                      ),
                                      _c(
                                        "option",
                                        { attrs: { value: "RHODIA" } },
                                        [_vm._v(" RHODIA ")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                { attrs: { label: "Date" } },
                                [
                                  _c("b-datepicker", {
                                    attrs: {
                                      name: "date",
                                      "first-day-of-week": 1,
                                      locale: "en-CA",
                                      icon: "calendar-alt",
                                      placeholder: "Date",
                                    },
                                    model: {
                                      value: _vm.editableBooking.date,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editableBooking,
                                          "date",
                                          $$v
                                        )
                                      },
                                      expression: "editableBooking.date",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                { attrs: { label: "Title" } },
                                [
                                  _c("b-input", {
                                    attrs: { type: "text" },
                                    model: {
                                      value: _vm.editableBooking.title,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editableBooking,
                                          "title",
                                          $$v
                                        )
                                      },
                                      expression: "editableBooking.title",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Number of Crates" } },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      type: "number",
                                      placeholder: "Crates",
                                    },
                                    model: {
                                      value: _vm.editableBooking.num_crates,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editableBooking,
                                          "num_crates",
                                          $$v
                                        )
                                      },
                                      expression: "editableBooking.num_crates",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                { attrs: { label: "Activity" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type:
                                          _vm.editableBooking.leaving == true
                                            ? "is-success"
                                            : "is-light",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeLeaving(true)
                                        },
                                      },
                                    },
                                    [_vm._v(" Delivery/Transfer out ")]
                                  ),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type:
                                          _vm.editableBooking.leaving == false
                                            ? "is-success"
                                            : "is-light",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeLeaving(false)
                                        },
                                      },
                                    },
                                    [_vm._v(" Collect/Transfer in ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.editableBooking.comment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editableBooking,
                                      "comment",
                                      $$v
                                    )
                                  },
                                  expression: "editableBooking.comment",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }